function FauxFacet (params, index, count) {
  if (!params) {
    return ''
  }

  const props = {
    count: count || 0,
    index: index || 0,
    name: params.name || '',
    field: params.field || '',
  }

  const propName = props.name
  const countString = props.count ? `(${props.count})` : ''

  return `
    <div class="clc-ProductGrid_Facet clc-ProductGrid_Facet-accordion">
      <button
        class="clc-ProductGrid_FacetsTrigger fz-14_140"
        type="button"
        data-drawers-trigger="results-filters"
        data-results-filters-el="fauxFacetTrigger"
        data-accordion="facet-${props.field}"
      >
        ${propName}
        ${countString}
      </button>
    </div>
  `
}

window.templates.FauxFacet = FauxFacet
